@if (folderStore.folder()) {
    <app-folder-continuous-record
        class="subpage-content"
    ></app-folder-continuous-record>
} @else {
    <app-work-continuous-record
        class="pt-2 subpage-content"
        [personIdInput]="folderStore.folder()?.personId || null"
        (closeCallback)="dialogRef.close()"
    ></app-work-continuous-record>
}

<div #dialogFooter></div>
